"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));
var _updatePaymentMethod = _interopRequireWildcard(require("../../../utils/cart/updatePaymentMethod"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Headline = _interopRequireDefault(require("../../../components/views/Headline"));
var _Price = _interopRequireDefault(require("../../../components/Cart/Price"));
var _Select = _interopRequireDefault(require("../../../components/Select"));
var _TotalPrice = _interopRequireDefault(require("../../../components/Cart/TotalPrice"));
var _PaymentMethods = _interopRequireDefault(require("./PaymentMethods.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PaymentMethods = _ref => {
  let {
    defaultLang = "de"
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    cart,
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const {
    paymentMethods = [],
    prices
  } = cart || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const navigate = (0, _useLink.default)();
  const css = (0, _PaymentMethods.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if ((paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) === 1) {
      var _paymentMethods$;
      const paymentMethodID = paymentMethods === null || paymentMethods === void 0 || (_paymentMethods$ = paymentMethods[0]) === null || _paymentMethods$ === void 0 ? void 0 : _paymentMethods$.id;
      if (paymentMethodID) handleChange(paymentMethodID, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  const isSelected = (0, _react.useMemo)(() => {
    return paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.some(_ref2 => {
      let {
        selected
      } = _ref2;
      return selected;
    });
  }, [paymentMethods]);
  const handleChange = async function (id) {
    let disableSuccessMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const response = await (0, _updatePaymentMethod.default)(id);
    const {
      msg
    } = response || {};
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_updatePaymentMethod.UPDATE_PAYMENT_METHOD_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    if (!disableSuccessMsg) {
      setMessageObj({
        message: l("reactShop.messages.success.PAYMENT_METHOD_UPDATED"),
        type: "success"
      });
    }
  };
  const handleSubmit = () => {
    if (!isSelected) {
      setMessageObj({
        message: l("reactShop.messages.errors.PAYMENT_METHOD_MISSING"),
        type: "error"
      });
      return;
    }
    navigate("/".concat(lang, "/shop/checkout"));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.paymentMethods, "mco-shop-payment-methods")
  }, /*#__PURE__*/_react.default.createElement(_Headline.default, {
    headline: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.paymentMethods.headline",
      l: l
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__right-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__price-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__price"
  }, /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang,
    prices: prices
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__total-price"
  }, /*#__PURE__*/_react.default.createElement(_TotalPrice.default, {
    lang: lang,
    prices: prices
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__button"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    fullWidth: true,
    variant: "contained",
    onClick: handleSubmit
  }, l("reactShop.checkout.buttons.next"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__content"
  }, paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.map(paymentMethod => {
    const {
      id,
      identifier = "post",
      selected = false,
      title
    } = paymentMethod;
    return /*#__PURE__*/_react.default.createElement(_Select.default, {
      checked: selected,
      id: id,
      identifier: identifier,
      key: id,
      label: title,
      onChange: handleChange
    });
  }))));
};
var _default = exports.default = PaymentMethods;